import { mergeUint8 } from '@polkadot-api/utils';
import { blake3 } from '@noble/hashes/blake3';

const len32 = { dkLen: 32 };
const Blake3256 = (encoded) => blake3(encoded, len32);
const Blake3256Concat = (encoded) => mergeUint8(Blake3256(encoded), encoded);

export { Blake3256, Blake3256Concat };
//# sourceMappingURL=blake3.mjs.map
